export {};

declare global {
  interface Window {
    webkit?: {
      messageHandlers?: {
        [x: string]: {
          postMessage: (method: string) => void;
        };
      };
    };
  }
}

window.global = globalThis;
window.webkit = window.webkit || {};
